import type { ValueFormatterParams } from 'ag-grid-community';
import moment from 'moment';

/**
 * utcをyyyy-MM-ddにフォーマット
 * @param ValueFormatterParams
 * @returns YYYY-MM-DD
 */
const dateFormatter = (params: ValueFormatterParams) => {
  const value = params.value;
  if (value) {
    return moment(value).format('YYYY-MM-DD');
  } else {
    return null;
  }
};

export default dateFormatter;
